<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="false" contentStyleClass="pt-2 "
    [style]="{ width: '90vw', maxWidth: '500px' } ">

    <div class="flex flex-col items-center text-center p-6 space-y-4 ">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />


        <div class="bg-custom-blue rounded-full h-[90px] w-[90px]  flex items-center justify-center">
            <i class="fas fa-check text-white custom-thick-icon  fa-3x"></i>
        </div>

        <div class="mb-6">
            <h2 class=" text-3xl font-semibold mt-2">Payment Successful!</h2>
        </div>

        <div class="w-full mt-10 pt-6 ">

            <div *ngFor="let line of thankyouPageLine" class="flex justify-between items-center ">

                <p class=" text-sm font-semibold font-mulish " style="color: var(--panorama-gray);">
                    {{line.quantity}} {{line.name}}</p>
                <span class="font-semibold font-mulish text-black text-lg">
                    $ {{line.value}} {{currency()}}
                </span>

            </div>
            <div class="flex justify-between items-center pb-6  border-b border-gray-200 ">
                <p class="text-sm font-semibold font-mulish" style="color: var(--panorama-gray);">
                    Transaction Fee:
                </p>
                <span class="font-semibold ml-10 font-mulish text-black text-lg">
                    $ {{thankYouData?.fee}} {{currency()}}
                </span>
            </div>

            <div class="flex justify-between items-center pt-6 ">
                <p class="text-xl font-bold font-mulish">
                    Total:
                </p>
                <span class="font-bold font-mulish text-black text-xl ">
                    $ {{total}} {{currency()}}
                </span>
            </div>

        </div>

        <div class="w-full pt-4">
            <button pButton class="p-button-info rounded-lg w-full mt-10 flex items-center justify-center gap-2 mt-6"
                [rounded]="true" [routerLink]="['/auction', thankYouData?.auctionId]">
                <i class="fa-solid fa-circle-check "></i>
                <span class="flex-1 text-center font-medium font-mulish text-base">Done</span>
            </button>
        </div>
    </div>


    <ng-template #isPurchaseItem>


    </ng-template>

</p-dialog>